import MiniProgramPage from 'D:/zxl/workspace/saveWorkSpace/nongtou-uni/subpackage/user/schedule.vue'
wx.createPage(MiniProgramPage)